import { DashboardAction } from '../../actions/dashboard/DashboardAction'
import { IDashboardState } from './IDashboardState'
import DashboardActionTypes from '../../actions/dashboard/DashboardActionTypes'
import { Order } from '../../../../entities/order/Order'
import { isSameDay, startOfDay } from 'date-fns'

export const initialState: IDashboardState = {
  columns: [],
  error: null,
  isRequesting: false,
  selectedDate: new Date(),
  availableDays: null,
  productsInProcessing: [],
  openCycles: {},
  lastAffectedOrder: null,
  vehicles: [],
  storeName: '',
  refreshInterval: 1 * 60 * 1000, // every minute by default
  defaultLanguage: null,
  productLoadingStates: {},
}

export const DashboardReducer = function Dashboard(state: IDashboardState = { ...initialState }, action: DashboardAction): IDashboardState {
  switch (action.type) {
    case DashboardActionTypes.REQUEST_AVAILABLE_DAYS_SUCCESS:
      return {
        ...state,
        availableDays: action.payload.availableDays,
      }

    case DashboardActionTypes.SET_OPEN_CYCLE:
      return {
        ...state,
        openCycles: {
          ...state.openCycles,
          [action.payload.step]: action.payload.cycleCode,
        },
      }

    case DashboardActionTypes.REQUEST_DASHBOARD:
      return {
        ...state,
        isRequesting: true,
      }

    case DashboardActionTypes.SET_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.payload.date,
        vehicles: isSameDay(startOfDay(new Date()), action.payload.date) ? state.vehicles : [],
      }

    case DashboardActionTypes.REQUEST_DASHBOARD_SUCCESS: {

      const newOpenCycles = action.payload.shouldResetOpenCycles ? {} : state.openCycles
      const lastAffectedOrder = state.lastAffectedOrder
      if (lastAffectedOrder) {
        const newOrders = action.payload.columns.reduce<Order[]>((orders, column) => ([
          ...orders,
          ...column.getAllOrders(),
        ]), [])

        const affectedOrders = newOrders.filter(({ orderId }) => orderId === lastAffectedOrder.orderId)

        if (affectedOrders.length) {
          affectedOrders.forEach(order => {
            newOpenCycles[order.cycle.column.step] = order.cycle.code
          })
        }
      }

      return {
        ...state,
        columns: action.payload.columns,
        isRequesting: false,
        productsInProcessing: [],
        openCycles: newOpenCycles,
      }
    }

    case DashboardActionTypes.RESET_LAST_AFFECTED_ORDER:
      return {
        ...state,
        lastAffectedOrder: null,
      }

    case DashboardActionTypes.REQUEST_DASHBOARD_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        productsInProcessing: [],
      }

    case DashboardActionTypes.REQUEST_PRODUCT_ACCEPT:
      return {
        ...state,
        productsInProcessing: [
          ...state.productsInProcessing,
          action.payload.product,
        ],
        lastAffectedOrder: action.payload.product.order,
      }

    case DashboardActionTypes.REQUEST_PRODUCT_DECLINE:
      return {
        ...state,
        productsInProcessing: [
          ...state.productsInProcessing,
          action.payload.product,
        ],
        lastAffectedOrder: action.payload.product.order,
      }

    case DashboardActionTypes.REQUEST_PRINT:
      return {
        ...state,
        productsInProcessing: [
          ...state.productsInProcessing,
          action.payload.product,
        ],
        lastAffectedOrder: action.payload.product.order,
      }

    case DashboardActionTypes.SET_FAILED_ORDER_ID:
      return {
        ...state,
        failedOrder: {
          orderId: action.payload.orderId,
          reason: action.payload.reason,
        },
      }

    case DashboardActionTypes.RESET_FAILED_ORDER_ID:
      return {
        ...state,
        failedOrder: undefined,
      }

    case DashboardActionTypes.REQUEST_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicles: action.payload.vehicles,
      }

    case DashboardActionTypes.REQUEST_SETTINGS_SUCCESS:
      return {
        ...state,
        storeName: action.payload.storeName,
        refreshInterval: action.payload.refreshInterval,
        defaultLanguage: action.payload.defaultLanguage,
      }

    case DashboardActionTypes.OPEN_CONFIRM_DIALOG:
      return {
        ...state,
        declinedProductForConfirmation: action.payload.declinedProduct,
        declinedProductCallback: action.payload.onEnd,
      }
    case DashboardActionTypes.CLOSE_CONFIRM_DIALOG:
      return {
        ...state,
        declinedProductForConfirmation: undefined,
        declinedProductCallback: undefined,
        productsInProcessing: [],
      }
    case DashboardActionTypes.CONFIRM_ACCEPT_DECLINED_PRODUCT:
      return {
        ...state,
        declinedProductForConfirmation: undefined,
        declinedProductCallback: undefined,
      }

    case DashboardActionTypes.DAY_TRANSITION_DETECTED:
      return {
        ...state,
        // Reset selected date to today when day transitions
        selectedDate: new Date(),
        // Clear vehicles since they're date-specific
        vehicles: [],
      }

    case DashboardActionTypes.DAY_TRANSITION_REFRESH:
      return {
        ...initialState,
        // Keep user settings and auth-related data
        storeName: state.storeName,
        refreshInterval: state.refreshInterval,
      }

    case DashboardActionTypes.SET_PRODUCT_LOADING:
      console.log('Dashboard reducer SET_PRODUCT_LOADING - productKey:', action.payload.productKey, 'isLoading:', action.payload.isLoading)
      const newProductLoadingStates = {
        ...state.productLoadingStates,
        [action.payload.productKey]: action.payload.isLoading,
      }
      console.log('Dashboard reducer new productLoadingStates:', newProductLoadingStates)
      return {
        ...state,
        productLoadingStates: newProductLoadingStates,
      }

    default:
      return state
  }
}

